export default __webpack_public_path__ + "static/media/vet.ca5c71c9.png";